<template>
  <div class="home">
    <h2 class="title">{{ $t("Meals") }}</h2>
    <TutorialBox id="planList">
      <p>{{ $t("Make a plan.") }}</p>
      <p>
        {{
          $t(
            "From your recipes, add those for which you want to shop the required ingredients."
          )
        }}
      </p>
    </TutorialBox>
    <ol class="selected-meals">
      <meal v-for="meal in meals" v-bind:meal="meal" v-bind:key="meal.id" />
    </ol>
    <a
      class="button is-text is-hidden-print"
      @click="clearMeals"
      v-if="meals.length"
    >
      {{ $t("Start fresh plan") }}
    </a>
    <p v-if="!recipes.length">
      {{ $t("no-recipes") }}
      <router-link to="/recipes">{{ $t("add-recipe") }}</router-link>
    </p>
    <meal-add
      :recipes="recipes"
      class="is-hidden-print"
      v-if="recipes.length"
    />
  </div>
</template>

<script>
import Vue from "vue";
import Meal from "@/components/Meal.vue";
import MealAdd from "@/components/MealAdd.vue";
import TutorialBox from "@/components/TutorialBox";

export default Vue.extend({
  name: "home",
  data: function () {
    return {};
  },
  methods: {
    clearMeals() {
      if (
        confirm(
          this.$t(
            "Are you done with your current plan and ready to start a fresh one?"
          )
        )
      ) {
        this.$store.dispatch("clearMeals");
      }
    },
  },
  computed: {
    recipes: function () {
      return this.$store.state.recipes;
    },
    meals: function () {
      return this.$store.state.meals;
    },
  },
  components: {
    Meal,
    MealAdd,
    TutorialBox,
  },
});
</script>

<style scoped>
.selected-meals {
  padding-left: 1.25rem;
}
</style>
<i18n>
{
  "en": {
    "Meals": "Meals",
    "no-recipes":"You have no recipes yet.",
    "add-recipe": "Add a recipe"
},
  "de": {
    "Meals": "Mahlzeiten",
    "Start fresh plan": "Neuen Plan starten",
    "Are you done with your current plan and ready to start a fresh one?": "Bist du fertig mit deinem aktuellen Plan und möchtest einen neuen starten?",
    "Make a plan.": "Mache einen Plan.",
    "From your recipes, add those for which you want to shop the required ingredients.": "Wähle aus deinen Rezepten, was du in der nächsten Zeit kochen möchtest. Die Zutaten kommen dann auf deine Einkaufsliste.",
    "no-recipes": "Du hast noch keine Rezepte.",
    "add-recipe": "Rezept hinzufügen"
  }
}
</i18n>
